import { sleep, sleep_cancelable } from '../../helpers/index.js';


const SUB_HEADER_BYTE = 35  // '#'

// TargetType
const TargetType = {
    RobotEsp: 160, // 0xA0
    RobotUno: 161, // 0xA1
};

// PacketType
const PacketType = {
    Command: 0,
    Request: 1,
};

const POSE_GROUPS = {
    LOW: 0,
    MIDDLE: 25,
    HIGH: 34,    
    DEFENSE: 13,
    SHRINK: 16,
    //FLIP_STAND_UP: 90,
};

// Define outside the class
const ACTION_GROUPS = {
    ATTACK: 5,
    RETREAT: 6,
    TURN_AROUND: 9,
    FIGHTING: 10,
    KICKING: 11,
    GREETING: 12,
    DANCING: 14,
    TWIST: 17,
    CLIMBING: 18,
    //LIFT_LEG_1: 102,
    //LIFT_LEG_2: 103,
    //LIFT_LEG_3: 104,
    //LIFT_LEG_4: 105,
    //LIFT_LEG_5: 106,
    //LIFT_LEG_6: 107,
};

const TRAVEL_GROUPS = {
    STOP: 902,
    SLIDE_LEFT: 7,
    SLIDE_RIGHT: 8,
    
    //FLIP_FORWARD: 91,
    //FLIP_BACKWARD: 92,
    //FLIP_TURN_LEFT: 93,
    //FLIP_TURN_RIGHT: 94,

    FORWARD_SMALL_STEP_LOW: 1,
    BACKWARD_SMALL_STEP_LOW: 2,
    TURN_LEFT_SMALL_STEP_LOW: 3,
    TURN_RIGHT_SMALL_STEP_LOW: 4,

    FORWARD_LARGE_STEP_LOW: 21,
    BACKWARD_LARGE_STEP_LOW: 22,
    TURN_LEFT_LARGE_STEP_LOW: 23,
    TURN_RIGHT_LARGE_STEP_LOW: 24,
    
    FORWARD_SMALL_STEP_MIDDLE: 26,
    BACKWARD_SMALL_STEP_MIDDLE: 27,
    TURN_LEFT_SMALL_STEP_MIDDLE: 28,
    TURN_RIGHT_SMALL_STEP_MIDDLE: 29,

    FORWARD_LARGE_STEP_MIDDLE: 30,
    BACKWARD_LARGE_STEP_MIDDLE: 31,
    TURN_LEFT_LARGE_STEP_MIDDLE: 32,
    TURN_RIGHT_LARGE_STEP_MIDDLE: 33,

    FORWARD_SMALL_STEP_HIGH: 35,
    BACKWARD_SMALL_STEP_HIGH: 36,
    TURN_LEFT_SMALL_STEP_HIGH: 37,
    TURN_RIGHT_SMALL_STEP_HIGH: 38,

    FORWARD_MEDIUM_STEP_MIDDLE: 39,
    BACKWARD_MEDIUM_STEP_MIDDLE: 40,
    TURN_LEFT_MEDIUM_STEP_MIDDLE: 41,
    TURN_RIGHT_MEDIUM_STEP_MIDDLE: 42,

    FORWARD_MEDIUM_STEP_LOW: 43,
    BACKWARD_MEDIUM_STEP_LOW: 44,
    TURN_LEFT_MEDIUM_STEP_LOW: 45,
    TURN_RIGHT_MEDIUM_STEP_LOW: 46,

};

const POSE_GROUP_DELAYS = {
    LOW: 1000,
    MIDDLE: 1000,
    HIGH: 1000,
    DEFENSE: 1500,
    SHRINK: 1500,
    //FLIP_STAND_UP: 1000,
};

const ACTION_GROUP_DELAYS = {
    ATTACK: 2000,
    RETREAT: 2000,
    TURN_AROUND: 26000,
    FIGHTING: 7000,
    KICKING: 9500,
    GREETING: 5000,
    DANCING: 2500,
    TWIST: 2000,
    CLIMBING: 15000,
};

const TRAVEL_GROUP_DELAYS = {    
    SLIDE_LEFT: 900,
    SLIDE_RIGHT: 900,
    //FLIP_FORWARD: 500,
    //FLIP_BACKWARD: 500,
    //FLIP_TURN_LEFT: 500,
    //FLIP_TURN_RIGHT: 500,
    FORWARD_SMALL_STEP_LOW: 500,
    BACKWARD_SMALL_STEP_LOW: 500,
    TURN_LEFT_SMALL_STEP_LOW: 500,
    TURN_RIGHT_SMALL_STEP_LOW: 500,
    FORWARD_LARGE_STEP_LOW: 700,
    BACKWARD_LARGE_STEP_LOW: 700,
    TURN_LEFT_LARGE_STEP_LOW: 700,
    TURN_RIGHT_LARGE_STEP_LOW: 700,
    FORWARD_SMALL_STEP_MIDDLE: 600,
    BACKWARD_SMALL_STEP_MIDDLE: 600,
    TURN_LEFT_SMALL_STEP_MIDDLE: 650,
    TURN_RIGHT_SMALL_STEP_MIDDLE: 650,
    FORWARD_LARGE_STEP_MIDDLE: 800,
    BACKWARD_LARGE_STEP_MIDDLE: 800,
    TURN_LEFT_LARGE_STEP_MIDDLE: 650,
    TURN_RIGHT_LARGE_STEP_MIDDLE: 650,
    FORWARD_SMALL_STEP_HIGH: 600,
    BACKWARD_SMALL_STEP_HIGH: 600,
    TURN_LEFT_SMALL_STEP_HIGH: 450,
    TURN_RIGHT_SMALL_STEP_HIGH: 450,
    FORWARD_MEDIUM_STEP_MIDDLE: 800,
    BACKWARD_MEDIUM_STEP_MIDDLE: 800,
    TURN_LEFT_MEDIUM_STEP_MIDDLE: 650,
    TURN_RIGHT_MEDIUM_STEP_MIDDLE: 650,
    FORWARD_MEDIUM_STEP_LOW: 500,
    BACKWARD_MEDIUM_STEP_LOW: 500,
    TURN_LEFT_MEDIUM_STEP_LOW: 500,
    TURN_RIGHT_MEDIUM_STEP_LOW: 500,
};


const RGB_STYLE = {
    Standard: 0,
    Breathing: 1,
};


export const ACTION_GROUP_STRINGS = Object.keys(ACTION_GROUPS).map(key => key.replace(/_/g, ' '));
export const ACTION_GROUP_REF_MAP = {};
Object.keys(ACTION_GROUPS).forEach(key => {
    const str = key.replace(/_/g, ' ');
    ACTION_GROUP_REF_MAP[str] = `locohex.${key}`;
});

export const POSE_GROUP_STRINGS = Object.keys(POSE_GROUPS).map(key => key.replace(/_/g, ' '));
export const POSE_GROUP_REF_MAP = {};
Object.keys(POSE_GROUPS).forEach(key => {
    const str = key.replace(/_/g, ' ');
    POSE_GROUP_REF_MAP[str] = `locohex.${key}`;
});

export const RGB_STYLE_STRINGS = Object.keys(RGB_STYLE).map(key => key.replace(/_/g, ' '));
export const RGB_STYLE_REF_MAP = {};
Object.keys(RGB_STYLE).forEach(key => {
    const str = key.replace(/_/g, ' ');
    RGB_STYLE_REF_MAP[str] = `locohex.${key}`;
});


class LocoHex {

    constructor() {
        
        this.bufferSize = 100;

        this.optionNames = [
            'Distance', 'Battery', 'IR Proximity', 'Touch', 'Sound', //'Color',
        ];

        this.options = {
            'Distance': { refer: 'READ_DISTANCE', count: 1, range: ['min'], offset: 0 },
            'Battery': { refer: 'READ_BATTERY', count: 1, range: ['fixed'], fixed: [8, 13] },
            'IR Proximity': { refer: 'READ_IR', count: 2, range: ['fixed'], fixed: [-0.1, 1.1] },
            'Touch': { refer: 'READ_TOUCH', count: 1, range: ['fixed'], fixed: [-0.1, 1.1] },
            'Sound': { refer: 'READ_SOUND', count: 1, range: ['fixed'], fixed: [0, 1024] },
        };
        
        this.self = {
            READ_DISTANCE: {
                value: ['get_distance'],
                names: ['Distance'],
                ylabels: ["Distance (cm)"],
                arrays: ['distArray'],
            },
            READ_BATTERY: {
                value: ['get_battery'],
                names: ['Battery'],
                ylabels: ["Battery (V)"],
                arrays: ['batteryArray'],
            },
            READ_IR: {
                value: ['get_ir_both'],
                names: ['IR FL', 'IR FR'],
                ylabels: ["IR Proximity FL", "IR Proximity FR"],
                arrays: ['irFLArray', 'irFRArray'],
            },
            READ_TOUCH: {
                value: ['get_touch'],
                names: ['Touch'],
                ylabels: ["Touch (#)"],
                arrays: ['touchArray'],
            },
            READ_SOUND: {
                value: ['get_sound'],
                names: ['Sound'],
                ylabels: ["Sound (#)"],
                arrays: ['soundArray'],
            },
            distArray: [],
            batteryArray: [],
            irFLArray: [],
            irFRArray: [],
            touchArray: [],
            soundArray: [],
        };

        this.canceled = false;

        this.port = null;
        this.reader = null;
        this.writer = null;

        this.lhTimeoutID = null;
        this.TIMEOUT_STR = "timeout";
        this.TIMEOUT_MAX = 3000;
        this.timeout_count = 0;
        
        this.can_process = false;
        
        this.read_loop = {
            targetLen: 0,
            targetLenOff: 0,
            header: 0,
            hasTargetLength: false,
            hasHeader: false
        }
        
        this.read_buffer = {
            data: [],
        }

        this.robotData = {
            scanEnd: false,
            scanData: [],
            connectEnd: false,
            connectState: 0,
            connectFirmware: false,
            receivedData: false,
            waitFlag: false,
            waitData: "",
            messageData: {}
        }

        this.CONNECT_STATES = {
            CONNECT_OK: 0, 
            CONNECT_FAIL: 1,
        };

        this.COMMANDS = {
            WIFI_SCAN: 83, // 'S'
            WIFI_CONNECT: 67, // 'C'
            WIFI_DISCONNECT: 68, // 'D'
            PASSTHROUGH: 80, // 'P'
            MID_VERSION: 86, // 'V'
            SSID_LIST_ITEM: 76, // 'L'
            SSID_LIST_END: 69, // 'E'
            MID_CLEAR: 66, // 'B'
        };

        this.POSE = { ...POSE_GROUPS }; // Make a copy

        this.TRAVEL = { ...TRAVEL_GROUPS }; // Make a copy
            
        this.ACTION_GROUPS = { ...ACTION_GROUPS }; // Make a copy

        this.ROBOT_COMMAND = {
            // RobotUno commands
            Sonar: 0,
            ActionGroup: 1,
            Matrix: 2,
            // RobotEsp commands
            RGB: 0,
        };

        this.ROBOT_REQUEST = {
            // Uno and Esp Requests
            Version: 0,
            // Uno Requests // RobotUnoRequest
            Sound: 1,
            Touch: 2,
            IRFL: 3,
            IRFR: 4,
            Battery: 5,
            // Esp Requests // RobotEspRequest
            Distance: 1,
            Color: 2,
        }

        // RobotUnoAGStyle
        this.AG_STYLE = {
            Iteration: 0,
            Timed: 1,
            Speed: 2,
            Continuous: 3,
        }

        // RobotUnoMTXCmd
        this.RobotUnoMTXCmd = {
            Clear: 0,
            SetBrightness: 1,
            SetString: 2,
        };

        // RobotUnoMTXBhv
        this.MATRIX_STYLE = {
            Static: 0,
            Scrolling: 1,
        }

        // RobotEspRGB
        this.RGB_STYLE = { ...RGB_STYLE };

        this.COLOR_MAP = {
            0: 'None',
            1: 'Red',
            2: 'Green',
            3: 'Blue',
            4: 'White',
        };
    }

    resetArrays = () => {
        this.self.distArray = [];
        this.self.batteryArray = [];
        this.self.irFLArray = [];
        this.self.irFRArray = [];
        this.self.touchArray = [];
        this.self.soundArray = [];
    };

    send_command = async (ref_obj) => {

        // make copy of array names array
        let names = [...ref_obj.arrays]; 

        for (let funcName of ref_obj.value) {
            
            if (typeof this[funcName] === 'function') {
                let data = await this[funcName]();
                for (let i = 0; i < names.length; i++) {
                    
                    if (Array.isArray(data)) {
                        this.self[names[i]].push(data[i]);
                    } else {
                        this.self[names[i]].push(data);
                    }
                    // Handle buffer size
                    if (this.self[names[i]].length > this.bufferSize) {
                        this.self[names[i]].shift();
                    }
                }
            }
        }
    };

    get_data_array = (type) => {
        return type.map(name => this.self[name]);
    };

    set_buffer_size = (buffer_size) => {
        this.bufferSize = buffer_size
    };

    get_buffer_size = () => {
        return this.bufferSize
    };

    clearLHTimeout = () => {
        try {
            if (this.lhTimeoutID !== null) {
                window.clearTimeout(this.lhTimeoutID);
                this.lhTimeoutID = null;
            }
        } catch (err) { }
    }

    clearReadState = () => {

        this.read_loop = {
            targetLen: 0,
            targetLenOff: 0,
            header: 0,
            hasTargetLength: false,
            hasHeader: false
        }

        this.read_buffer = {
            data: [],
        }
        
        this.robotData = {
            scanEnd: false,
            scanData: [],
            connectEnd: false,
            connectState: 0,
            connectFirmware: false,
            receivedData: false,
            waitFlag: false,
            waitData: "",
            messageData: {}
        }


    }

    readLoop = async() => {
        while (true) {
            let output = await this.update_buffer();
            if (output === -1) {
                this.reader.releaseLock();
                break;
            } else if (output === -2) {
                try {
                    this.reader = this.port.readable.getReader();
                } catch {
                    this.reader.releaseLock();
                    break;                    
                }
            }
            if (this.can_process === true) {
                this.process_buffer();
            }
        }
    }

    update_buffer = async() => {
        try {
            const { value, done } = await this.reader.read()
            let nowPacket = new Uint8Array(value.buffer);
            if (this.can_process === true) {
                this.read_buffer.data = [...this.read_buffer.data , ...nowPacket]
            }
            if (done) {
                return -1;
            } else {
                return 0;
            }
        } catch (err) {
            return -2
        }
    };

    process_buffer = async() => {
        if (this.read_loop.hasHeader === false) {
            // Have Header Now
            this.read_loop.header = this.read_buffer.data[0]
            this.read_loop.hasHeader = true
            //console.log("Header Found:", this.read_loop.header);
    
            // Not enough data for length byte
            if (this.read_buffer.data.length < 3) {
                return;
            }
            this.read_loop.targetLen = this.read_buffer.data[1]
            this.read_loop.targetLenOff = 2
            this.read_loop.hasTargetLength = true

            //console.log("Target Length:", this.read_loop.targetLen);
    
            // Check if the rest of the packet is in the buffer - if not, return
            let fullLength = (this.read_loop.targetLen + this.read_loop.targetLenOff)
            if (this.read_buffer.data.length < fullLength) {
                return;
            }
    
            // Read Current Packet
            let myPacket = this.read_buffer.data.slice(0, fullLength)
    
            // Process Packet
            this.process_serial(myPacket)
    
            // Update Buffer without throwing out extra, if extra
            this.read_buffer.data = this.read_buffer.data.slice(fullLength, this.read_buffer.data.length)
    
            // Reset Parameters
            this.clear_packet_info()       
    
        } else {
            // Does Not Already Have Target Length?
            if (this.read_loop.hasTargetLength !== true) {
                
                // Not enough data for length byte
                if (this.read_buffer.data.length < 3) {
                    return;
                }
    
                this.read_loop.targetLen = this.read_buffer.data[1]
                this.read_loop.targetLenOff = 2
                this.read_loop.hasTargetLength = true

                //console.log("Target Length:", this.read_loop.targetLen);
            }
            
            // Check if the rest of the packet is in the buffer - if not, return
            let fullLength = (this.read_loop.targetLen + this.read_loop.targetLenOff)
            if (this.read_buffer.data.length < fullLength) {
                return;
            }
            
            // Read Current Packet
            let myPacket = this.read_buffer.data.slice(0, fullLength)
    
            // Process Packet
            this.process_serial(myPacket)
    
            // Update Buffer without throwing out extra, if extra
            this.read_buffer.data = this.read_buffer.data.slice(fullLength, this.read_buffer.data.length)
    
            // Reset Parameters
            this.clear_packet_info()
        }
    };

    process_serial = async(packet) => {
        
        switch (packet[0]) {
            case this.COMMANDS.SSID_LIST_ITEM: {
                let name = packet.slice(2, 2 + packet[1]);
                name = String.fromCharCode.apply(null, name);
                this.robotData['scanData'].push(name)
                break;
            }
            case this.COMMANDS.SSID_LIST_END: {
                this.robotData['scanEnd'] = true;
                break
            }
            case this.COMMANDS.WIFI_CONNECT: {
                this.robotData['connectEnd'] = true;
                this.robotData['connectState'] = packet[2];
                break
            }
            case this.COMMANDS.WIFI_DISCONNECT: {
                this.robotData['connectEnd'] = true;
                this.robotData['connectState'] = packet[2];
                break
            }
            case SUB_HEADER_BYTE: {
                this.process_passthrough(packet.slice(2));
            }
            case this.COMMANDS.MID_VERSION: {
                break
            }
            default: {
                //let message = String.fromCharCode.apply(null, packet.slice(2));
                //console.log("misc message:", message);
                break;
            }
        }
        
    };

    process_passthrough = (data) => {
        
        const target_type = data[0]
        const packet_type = data[1] // request or command

        if (target_type === TargetType.RobotEsp) {
            if (packet_type === PacketType.Request) {
                const request_type = data[2] // this.ROBOT_REQUEST
                switch (request_type) {
                    case this.ROBOT_REQUEST.Version: {
                        const firmware_version = data[3];
                        const firwmare_revision = data[4];
                        this.robotData['messageData']['version'] = firmware_version
                        this.robotData['messageData']['revision'] = firwmare_revision
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    case this.ROBOT_REQUEST.Distance: {
                        const distance = (data[4] << 8) | data[3];
                        if (distance < 5000)
                            this.robotData['messageData']['distance'] = distance;
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    case this.ROBOT_REQUEST.Color: {
                        const color = data[3];
                        const color_str = this.COLOR_MAP[color];
                        this.robotData['messageData']['color'] = color_str;
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    default: {
                        this.robotData['receivedData'] = true;
                        break;
                    }
                }
            }

        } else if (target_type === TargetType.RobotUno) {
            if (packet_type === PacketType.Request) {
                const request_type = data[2] // this.ROBOT_REQUEST
                switch (request_type) {
                    case this.ROBOT_REQUEST.Version: {
                        const firmware_version = data[3];
                        const firwmare_revision = data[4];
                        this.robotData['messageData']['version'] = firmware_version
                        this.robotData['messageData']['revision'] = firwmare_revision
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    case this.ROBOT_REQUEST.Sound: {
                        const sound = (data[3] << 8) | data[4];
                        this.robotData['messageData']['sound'] = sound;
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    case this.ROBOT_REQUEST.Touch: {
                        const touch = data[3];
                        this.robotData['messageData']['touch'] = 1 - touch;
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    case this.ROBOT_REQUEST.IRFL: {
                        const irFL = data[3];
                        this.robotData['messageData']['irFL'] = irFL;
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    case this.ROBOT_REQUEST.IRFR: {
                        const irFR = data[3];
                        this.robotData['messageData']['irFR'] = irFR;
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    case this.ROBOT_REQUEST.Battery: {
                        let battery = (data[3] << 8) | data[4];
                        battery /= 1000.0; // Convert mV to volts
                        battery = Math.round(battery * 10) / 10;
                        this.robotData['messageData']['battery'] = battery;
                        this.robotData['receivedData'] = true;
                        break;
                    }
                    default: {
                        this.robotData['receivedData'] = true;
                        break;
                    }
                }

            }
        } else {
            this.robotData['receivedData'] = true;
        }
    };

    clear_packet_info = () => {
        this.read_loop.header = 0
        this.read_loop.hasHeader = false
        this.read_loop.targetLen = 0
        this.read_loop.hasTargetLength = false
        this.read_loop.targetLenOff = 0
    };
    
    // Write Data Packet Over WebSerial
    write_packet = async (data, disable_process_check = false) => {
        //console.log("write:", data);
        let packet = Uint8Array.from(data);
        await this.webserial_write(packet, disable_process_check);
    };
    webserial_write = async(data, disable_process_check = false) => {
        if (disable_process_check === false) {
            if (this.can_process === false) {
                this.can_process = true
            }
        }
        //console.log("write:", data);
        const writer = this.port.writable.getWriter();
        await writer.write(data);
        writer.releaseLock();
    };


    setup = async () => {
        return await this.connect_usb();
    };

    connect_usb = async() => {

        this.clearLHTimeout();
        this.clearReadState();
        this.can_process = false;

        await sleep(500);

        // If port exists and is open, close it first
        if (this.port && this.port.readable && this.port.writable) {
            try {
                // Release the reader if it exists
                if (this.reader) {
                    try {
                        await this.reader.cancel();
                    } catch (err) {
                        // Ignore cancel errors
                    }
                    try {
                        this.reader.releaseLock();
                    } catch (err) {
                        // Ignore releaseLock errors
                    }
                    this.reader = null;
                }
                await this.port.close();
            } catch (err) {
                console.log("Error closing already open port:", err);
            }
            this.port = null;
        }

        // - Request a port and open a connection.
        try {
            const usbVendorId = 0x10C4;
            this.port = await navigator.serial.requestPort({ filters: [{ usbVendorId }]});
        } catch(err) {
            console.log("error", err)
            return -1; // Indicate failure
        }
        try {
            // - Wait for the port to open.
            await this.port.open({ baudRate: 115200, bufferSize: 2048 });

            this.reader = this.port.readable.getReader();
            
            this.readLoop();
            await sleep(1000);

            // 
            let packet = [this.COMMANDS.MID_CLEAR, 1, 0]; // clear, length, 0
            await this.write_packet(packet, true);

            await sleep(2000);
            
            this.canceled = false;
            return 0;
        } catch (err) {
            console.log(err);
            return -1; // Indicate failure
        }
    }

    connect = async () => {
        
        let me = this;
        return new Promise(async function (resolve, reject) {

            var m = function() {
                resolve("done");
            }
            return me.connect_usb().then(() => {
                me.lhTimeoutID = window.setTimeout(m, 4000);
            }).catch((err) => {
                resolve("error")
            });
        });
    }

    scan = async () => {
        return await this.wifi_scan();
    };

    wifi_scan = async() => {
        try {
            let scan_packet = [this.COMMANDS.WIFI_SCAN, 1, 0]; // scan, length, 0
            await this.write_packet(scan_packet);

            this.robotData['scanEnd'] = false;
            this.robotData['scanData'] = [];

            let me = this;
            this.timeout_count = 0;
            
            return new Promise(function (resolve, reject) {     
                var f = function () {
                    if (me.robotData['scanEnd'] === true) {
                        resolve(me.robotData['scanData']);
                    } else {
                        if (me.timeout_count < 30000) { // 15 seconds
                            me.lhTimeoutID = window.setTimeout(f, 5);
                        } else {
                            resolve(me.TIMEOUT_STR);
                        }                    
                        me.timeout_count += 10;
                    }
                }
                window.setTimeout(f, 5);
            });
        } catch (err) {
            //console.log("scan error: ", err);
            return []
        }
    };

    connect_wifi = async(ssid) => {
        await this.connectRobot(ssid);
    };

    connectRobot = async(ssid) => {
        const ssidBytes = new TextEncoder().encode(ssid);
        const ssidLength = ssidBytes.length;
        const connectPacket = new Uint8Array(2 + ssidLength);
        connectPacket[0] = this.COMMANDS.WIFI_CONNECT;
        connectPacket[1] = ssidLength;
        connectPacket.set(ssidBytes, 2);
        await this.webserial_write(connectPacket);

        this.robotData['connectEnd'] = false;
        this.robotData['connectState'] = 0;

        let me = this;
        const MAX_RETRIES = 3;
        let attempts = 0;
        
        return new Promise(function (resolve, reject) {
            
            let m = function () {
                me.set_rgbs(100, 100, 0, 100, 100, 0, RGB_STYLE.Breathing);
                resolve("done");
            }

            let f = function () {
                if (me.robotData['connectEnd'] === true) {
                    if (me.robotData['connectState'] !== me.CONNECT_STATES.CONNECT_OK) {
                        if (attempts < MAX_RETRIES) {
                            attempts++;
                            me.robotData['connectEnd'] = false;
                            me.robotData['connectState'] = 0;
                            me.webserial_write(connectPacket);
                            window.setTimeout(f, 1000); // Wait a bit before retrying
                        } else {
                            reject("Could Not Connect To The Robot. Please Try Running the Program Again.");
                        }
                    } else {
                        window.setTimeout(m, 2500);
                    }
                } else {
                    window.setTimeout(f, 5);
                }
            }

            window.setTimeout(f, 5);
        });
    }

    disconnect = async() => {
        try {
            await this.set_pose(this.POSE.LOW); // 
            await this.disconnect_wifi();
            await this.disconnect_serial();
        } catch (err) {
        } finally {
            this.clearLHTimeout();
            this.clearReadState();
        }
    };

    disconnect_quick = async() => {
        
        if (this.port !== null && this.port.readable && this.port.writable) {    
            try {
                this.canceled = true;
                await sleep(25);
                await this.set_pose(this.POSE.LOW);
                await sleep(25);
                await this.disconnect_wifi_quick();
                this.disconnect_serial();
            } catch (err) {
            } finally {
                this.clearLHTimeout();
                this.clearReadState();
            }
        }
    }

    disconnect_usb_quick = async() => {
        if (this.port !== null && this.port.readable && this.port.writable) {    
            try {
                await this.set_pose(this.POSE.LOW);
                //await sleep(500); // shorter pause
                this.disconnect_serial();
            } catch (err) {
            } finally {
                this.clearLHTimeout();
                this.clearReadState();
            }
        }
    };

    disconnect_wifi_quick = async() => {
        let packet = [this.COMMANDS.WIFI_DISCONNECT, 1, 0]; // disconnect, length, 0
        await this.write_packet(packet);
        await sleep(250);
    }

    disconnect_wifi = async() => {

        let packet = [this.COMMANDS.WIFI_DISCONNECT, 1, 0]; // disconnect, length, 0
        await this.write_packet(packet);

        this.robotData['connectEnd'] = false;
        this.robotData['connectState'] = 0;

        let me = this;
        this.timeout_count = 0;

        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['connectEnd'] === true) {
                    resolve("done");
                } else {
                    if (me.timeout_count < 30000) { // 15 seconds
                        me.lhTimeoutID = window.setTimeout(f, 5);
                    } else {
                        resolve(me.TIMEOUT_STR);
                    }
                    me.timeout_count += 10;
                }
            }
            window.setTimeout(f, 5);
        });
    }

    disconnect_serial = async() => {
        try {
            // Close the input stream (reader).
            if (this.reader) {
              try {
                  await this.reader.cancel();                
              } catch (err) {
              }
              this.reader = null;
            }
            // Close the port.
            await this.port.close();
            this.port = null;
          } catch (err) { }
    }

    writePassthrough = async (data) => {
        let packet = [this.COMMANDS.PASSTHROUGH, data.length];
        packet.push(...data);
        await this.write_packet(packet);
    };

    set_rgbs = async(r1, g1, b1, r2, g2, b2, mode = RGB_STYLE.Standard) => {
        // mode: this.RGB_STYLE.Standard or this.RGB_STYLE.Breathing
        const packet = [
            SUB_HEADER_BYTE, 
            10, // Length of the packet
            TargetType.RobotEsp, 
            PacketType.Command, 
            this.ROBOT_COMMAND.RGB, 
            mode, 
            r1, g1, b1, r2, g2, b2 // RGB values from inputs
        ];
        await this.writePassthrough(packet);
    };

    get_distance = async() => {
        // Write and send the request packet
        const packet = [
            SUB_HEADER_BYTE, 
            3, // Length of the packet
            TargetType.RobotEsp, 
            PacketType.Request, 
            this.ROBOT_REQUEST.Distance
        ];
        await this.writePassthrough(packet);
        
        // Wait for the response
        this.robotData['receivedData'] = false;
        let me = this;
        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    resolve(me.robotData['messageData']['distance']);
                } else {
                    me.lhTimeoutID = window.setTimeout(f, 5);
                }
            }
            window.setTimeout(f, 5);
        });
    };

    get_color = async() => {
        // Write and send the request packet
        const packet = [
            SUB_HEADER_BYTE,
            3, // Length of the packet
            TargetType.RobotEsp, 
            PacketType.Request, 
            this.ROBOT_REQUEST.Color
        ];
        await this.writePassthrough(packet);
        
        // Wait for the response
        this.robotData['receivedData'] = false;
        let me = this;
        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    resolve(me.robotData['messageData']['color']);
                } else {
                    me.lhTimeoutID = window.setTimeout(f, 5);
                }
            }
            window.setTimeout(f, 5);
        });
    };

    get_battery = async() => {

        const packet = [
            SUB_HEADER_BYTE, 
            3, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Request, 
            this.ROBOT_REQUEST.Battery
        ];
        await this.writePassthrough(packet);

        this.robotData['receivedData'] = false;
        let me = this;
        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    resolve(me.robotData['messageData']['battery']);
                } else {
                    me.lhTimeoutID = window.setTimeout(f, 5);
                }
            }
            window.setTimeout(f, 5);
        });
    };

    get_touch = async() => {

        const packet = [
            SUB_HEADER_BYTE, 
            3, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Request, 
            this.ROBOT_REQUEST.Touch
        ];
        await this.writePassthrough(packet);

        this.robotData['receivedData'] = false;
        let me = this;
        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    resolve(me.robotData['messageData']['touch']);
                } else {
                    me.lhTimeoutID = window.setTimeout(f, 5);
                }
            }
            window.setTimeout(f, 5);
        });
    };

    get_ir_fl = async() => {
        const packet = [
            SUB_HEADER_BYTE, 
            3, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Request, 
            this.ROBOT_REQUEST.IRFL
        ];
        await this.writePassthrough(packet);

        this.robotData['receivedData'] = false;
        let me = this;
        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    resolve(me.robotData['messageData']['irFL']);
                } else {
                    me.lhTimeoutID = window.setTimeout(f, 5);
                }
            }
            window.setTimeout(f, 5);
        });
    };

    get_ir_fr = async() => {
        const packet = [
            SUB_HEADER_BYTE, 
            3, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Request, 
            this.ROBOT_REQUEST.IRFR
        ];
        await this.writePassthrough(packet);

        this.robotData['receivedData'] = false;
        let me = this;
        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    resolve(me.robotData['messageData']['irFR']);
                } else {
                    me.lhTimeoutID = window.setTimeout(f, 5);
                }
            }
            window.setTimeout(f, 5);
        });
    };

    get_ir_both = async() => {
        const res_fl = await this.get_ir_fl();
        const res_fr = await this.get_ir_fr();
        return [res_fl, res_fr];
    };

    get_sound = async() => {
        const packet = [
            SUB_HEADER_BYTE, 
            3, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Request, 
            this.ROBOT_REQUEST.Sound
        ];
        await this.writePassthrough(packet);

        this.robotData['receivedData'] = false;
        let me = this;
        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    resolve(me.robotData['messageData']['sound']);
                } else {
                    me.lhTimeoutID = window.setTimeout(f, 5);
                }
            }
            window.setTimeout(f, 5);
        });
    };

    // Set the matrix display on the Robot Uno
    // string: The string to display on the matrix (max 16 characters)
    // style: this.MATRIX_STYLE.Static or this.MATRIX_STYLE.Scrolling
    // intervalMS: The interval in milliseconds for scrolling (only used if style is Scrolling)
    set_matrix = async(string, style = this.MATRIX_STYLE.Static, intervalMS = 0) => {
        
        if (string.length < 1)  {
            return;
        }
        else if (string.length > 16) {
            string = string.substring(0, 16);
        }

        if (!Object.values(this.MATRIX_STYLE).includes(style)) {
            return;
        }

        let packet = [
            SUB_HEADER_BYTE, 
            5 + string.length, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Command, 
            this.ROBOT_COMMAND.Matrix, 
            this.RobotUnoMTXCmd.SetString, 
            style, // Scrolling or Static
        ];
        if (style === this.MATRIX_STYLE.Static) {
            // Add the string to the packet
            for (let i = 0; i < string.length; i++) {
                packet.push(string.charCodeAt(i));
            }
        } else if (style === this.MATRIX_STYLE.Scrolling) {
            // add the interval in milliseconds
            packet.push(intervalMS & 0xFF); // Low byte
            packet.push((intervalMS >> 8) & 0xFF); // High byte
            // Add the string to the packet
            for (let i = 0; i < string.length; i++) {
                packet.push(string.charCodeAt(i));
            }
            // update the string length
            packet[1] += 2; // 5 for the header + 2 for the interval + string length
        }

        await this.writePassthrough(packet);
    };

    // Set the brightness of the matrix display on the Robot Uno
    // brightness: An integer between 0 and 8 (0 is off, 8 is maximum brightness)
    set_matrix_brightness = async(brightness) => {

        if (brightness < 0) brightness = 0;
        if (brightness > 8) brightness = 8;

        let packet = [
            SUB_HEADER_BYTE, 
            5, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Command, 
            this.ROBOT_COMMAND.Matrix,
            this.RobotUnoMTXCmd.SetBrightness, 
            brightness
        ];
        await this.writePassthrough(packet);
    };

    // Clear the matrix display on the Robot Uno
    // This will turn off all LEDs on the matrix
    // and reset the display to a blank state.
    clear_matrix = async() => {
        let packet = [
            SUB_HEADER_BYTE, 
            4, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Command, 
            this.ROBOT_COMMAND.Matrix, 
            this.RobotUnoMTXCmd.Clear
        ];
        await this.writePassthrough(packet);
    };


    set_sonar = async(angle) => {

        if (angle < 0 || angle > 180) {
            throw new Error('Angle must be between 0 and 180 degrees');
        }

        let packet = [
            SUB_HEADER_BYTE, 
            4, // Length of the packet
            TargetType.RobotUno, 
            PacketType.Command, 
            this.ROBOT_COMMAND.Sonar, 
            angle
        ];
        await this.writePassthrough(packet);

    };

    // Set the action group for the Robot Uno
    // actionGroup: The action group number (0-255)
    // style: The style of the action group (this.AG_STYLE.Iteration, this.AG_STYLE.Timed, or this.AG_STYLE.Speed)
    // iterations: The number of iterations for the action group (only used if style is this.AG_STYLE.Iteration)
    // durationMs: The duration in milliseconds for the action group (only used if style is this.AG_STYLE.Timed)
    // speed: The speed for the action group (only used if style is this.AG_STYLE.Speed, between 0 and 255)
    set_ag = async(actionGroup, style, { iterations, durationMs, speed } = {}) => {
        
        // Make Sure Style is Valid
        if (!Object.values(this.AG_STYLE).includes(style)) {
            //console.log("Invalid action group style:", style);
            throw new Error('Invalid action group style');
        }
        // If Iteration Style, Make Sure Iterations is Valid
        if (style === this.AG_STYLE.Iteration && iterations < 1) {
            //console.log("Invalid iterations:", iterations);
            throw new Error('Iterations cannot be negative');
        }

        // If Timed Style, Make Sure Duration is Valid
        if (style === this.AG_STYLE.Timed && durationMs < 100) {
            console.log("Invalid duration:", durationMs);
            throw new Error('Duration must be greater than 100 milliseconds');
        }

        //
        if (actionGroup !== this.TRAVEL.STOP) {
            if (style === this.AG_STYLE.Continuous) {
                iterations = 0; // Continuous uses 0 iterations
                style = this.AG_STYLE.Iteration; // Send as Iteration style
            }
        } else {
            if (style === this.AG_STYLE.Continuous) {
                actionGroup = this.TRAVEL.FORWARD_SMALL_STEP_LOW;
                style = this.AG_STYLE.Timed; // Send as Timed style
                durationMs = 0; // 0 duration for stop
            }
        }

        // If Speed Style, Make Sure Speed is Valid
        if (style === this.AG_STYLE.Speed && (speed < 0 || speed > 65535)) {
            //console.log("Invalid speed:", speed);
            throw new Error('Speed must be between 0 and 65535');
        }

        
        let groupName, delayObj, totalDelay;
        if (Object.values(this.ACTION_GROUPS).includes(actionGroup)) {
            groupName = Object.keys(this.ACTION_GROUPS).find(key => this.ACTION_GROUPS[key] === actionGroup);
            delayObj = ACTION_GROUP_DELAYS;
        } else if (Object.values(this.TRAVEL).includes(actionGroup)) {
            groupName = Object.keys(this.TRAVEL).find(key => this.TRAVEL[key] === actionGroup);
            delayObj = TRAVEL_GROUP_DELAYS;
        } else if (Object.values(this.POSE).includes(actionGroup)) {
            groupName = Object.keys(this.POSE).find(key => this.POSE[key] === actionGroup);
            delayObj = POSE_GROUP_DELAYS;
        }

        // Iteration style batching for large iteration counts
        if (style === this.AG_STYLE.Iteration && iterations > 10) {
            let remaining = iterations;

            while (remaining > 0) {
                let batch = Math.min(remaining, 10);
                let packet = [
                    SUB_HEADER_BYTE,
                    6,
                    TargetType.RobotUno,
                    PacketType.Command,
                    this.ROBOT_COMMAND.ActionGroup,
                    actionGroup,
                    this.AG_STYLE.Iteration,
                    batch
                ];
                await this.writePassthrough(packet);
                // Calculate wait time for batch
                let waitDelay = delayObj && delayObj[groupName] ? delayObj[groupName] * batch : 0;
                await sleep_cancelable(waitDelay, this);
                if (this.canceled === true) {
                    break;
                }
                remaining -= batch;
            }
            return;
        }

        // Timed style batching for large time spans
        if (style === this.AG_STYLE.Timed && durationMs > 30000) {
            let remaining = durationMs;
            while (remaining >= 1000) {
                let batch = Math.min(remaining, 30000);
                let packet = [
                    SUB_HEADER_BYTE,
                    9,
                    TargetType.RobotUno,
                    PacketType.Command,
                    this.ROBOT_COMMAND.ActionGroup,
                    actionGroup,
                    this.AG_STYLE.Timed,
                    batch & 0xFF,
                    (batch >> 8) & 0xFF,
                    (batch >> 16) & 0xFF,
                    (batch >> 24) & 0xFF
                ];
                await this.writePassthrough(packet);
                // Calculate wait time for batch
                let waitDelay = delayObj && delayObj[groupName] ? delayObj[groupName] + batch : batch;
                await sleep_cancelable(waitDelay, this);
                if (this.canceled === true) {
                    break;
                }
                remaining -= batch;
            }
            return;
        }

        totalDelay = typeof durationMs === 'number' ? durationMs : 0;
        if (groupName && delayObj && delayObj[groupName]) {
            if (style === this.AG_STYLE.Timed) {
                totalDelay += delayObj[groupName];
            } else if (style === this.AG_STYLE.Iteration) {
                const multipleDelay = delayObj[groupName] * (iterations || 1);
                totalDelay += multipleDelay;
            }
        }

        let packet = [
            SUB_HEADER_BYTE, 
            5,
            TargetType.RobotUno, 
            PacketType.Command, 
            this.ROBOT_COMMAND.ActionGroup, 
            actionGroup,
            style
        ];

        //
        if ((style === this.AG_STYLE.Iteration) || 
            (style === this.AG_STYLE.Continuous)) {
            packet.push(iterations);
            packet[1] += 1; // Update length byte for iterations
        }
        //
        else if (style === this.AG_STYLE.Timed) {
            packet.push(durationMs & 0xFF);
            packet.push((durationMs >> 8) & 0xFF);
            packet.push((durationMs >> 16) & 0xFF);
            packet.push((durationMs >> 24) & 0xFF);
            packet[1] += 4; // Update length byte for duration
        }

        // Add speed if style is Speed
        else if (style === this.AG_STYLE.Speed) {
            packet.push(speed & 0xFF);           // Low byte
            packet.push((speed >> 8) & 0xFF);    // High byte
            packet[1] += 2; // Update length byte for speed (now 2 bytes)
        }

        await this.writePassthrough(packet);

        // wait for the action group to complete
        //await sleep(totalDelay);
        await sleep_cancelable(totalDelay, this);
    };

    set_travel = async(actionGroup, style, { iterations, durationMs, speed } = {}) => {

        //
        if (!Object.values(this.TRAVEL).includes(actionGroup)) {
            throw new Error('Invalid action group number');
        }

        await this.set_ag(actionGroup, style, { iterations, durationMs, speed });
    };

    set_action_group = async(actionGroup, style, { iterations, durationMs, speed } = {}) => {

        if (!Object.values(this.ACTION_GROUPS).includes(actionGroup)) {
            //console.log("Invalid action group number:", actionGroup);
            throw new Error('Invalid action group number');
        }

        await this.set_ag(actionGroup, style, { iterations, durationMs, speed });
    };

    set_speed = async(actionGroup, speed) => {

        const style = this.AG_STYLE.Speed;

        if (
            !Object.values(this.POSE).includes(actionGroup) &&
            !Object.values(this.TRAVEL).includes(actionGroup) &&
            !Object.values(this.ACTION_GROUPS).includes(actionGroup)
        ) {
            //console.log("Invalid action group number:", actionGroup);
            throw new Error('Invalid action group number');
        }

        await this.set_ag(actionGroup, style, { speed });
    }

    set_pose = async(pose) => {

        if (!Object.values(this.POSE).includes(pose)) {
            throw new Error('Invalid pose');
        }

        await this.set_ag(pose, this.AG_STYLE.Iteration, { iterations: 1 });
    };

};


export { LocoHex };